<template>
  <div class="customizeContainer">
    <span>
        请选择生成风格
    </span>
    <ImageStyleSelect @changeImg="handleChangeImg" :options="customizeImgStyleOptions"/>
    <el-input
      type="textarea"
      placeholder="请输入自定义提示词，200字以内的中文、英文或数字"
      v-model="cue_word"
      maxlength="200"
      show-word-limit
      class="textArea"
      resize="none"
      rows="4"
    />
    <span class="instanceMessage">示例：中国画风格</span>
  </div>
</template>

<script>
import ImageStyleSelect from '../../ImageStyleSelect/index.vue'
import { customizeImgStyleOptions, FontStyle } from '../config';
export default {
  name: 'Customize',

  components: {
    ImageStyleSelect
  },

  data() {
    return {
      customizeImgStyleOptions,

      cue_word: '',
      style: FontStyle.Material,
    };
  },

  methods: {
    handleChangeImg(style) {
      this.style = style
    }
  },

  watch: {
    cue_word: function(newVal) {
      this.$emit('dataChange', {
        cue_word: newVal,
        style: this.style
      })
    },
    style: function(newVal) {
      this.$emit('dataChange', {
        style: newVal,
        cue_word: this.cue_word
      })
    }
  }
};
</script>

<style scoped lang="scss">
.customizeContainer {
  width: 100%;

  .textArea {
    margin-top: 16px
  }

  ::v-deep .el-textarea__inner {
    border: none;
    background: #F5F5F5;
    padding: 16px 15px;
  }

  ::v-deep .el-input__count{
    background: transparent;
  }

  .instanceMessage {
    display: inline-block;
    margin: 10px 0 0 0;
    color: #999999;
  }
}
</style>